import React, { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@blueprintjs/core';
import ModalDialog from 'shared/modal/dialog';
import {
  AdaptedAlarmNotificationProfile,
  AlarmNotificationProfile,
  AlarmNotificationProfileMenuActionsType,
} from 'data/alarmNotificationProfile/alarmNotificationProfile.types';
import './alarm-notification-profile-action-menu.scss';

type Props = {
  selectedItem?: AdaptedAlarmNotificationProfile;
  hasPrivilegesToCreate: boolean;
  hasPrivilegeToDelete: boolean;
  onEdit: () => void;
  onDelete: () => void;
}

const AlarmNotificationProfileMenu: FunctionComponent<Props> = ({
  selectedItem,
  hasPrivilegesToCreate,
  hasPrivilegeToDelete,
  onEdit,
  onDelete,
}: Props) => {

  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const { t } = useTranslation();

  const handleOpenDeleteDialog = () => {
    setIsDeleteDialogOpen(true);
  };

  const handleCloseDeleteDialog = () => {
    setIsDeleteDialogOpen(false);
  };

  const handleDelete = () => {
    onDelete();
    setIsDeleteDialogOpen(false);
  };

  if (selectedItem == null) {
    return null;
  }

  return (
    <div data-testid="AlarmNotificationProfileMenu" className="alarm-notification-profile-action-menu">
      {hasPrivilegesToCreate && (
        <Button
          className="alarm-notification-profile-action-menu-button"
          data-testid={`${AlarmNotificationProfileMenuActionsType.Edit}-button`}
          text={t('collectionFunction.grid.edit')}
          onClick={onEdit}
        />
      )}
      {hasPrivilegeToDelete && (
        <Button
          className="alarm-notification-profile-action-menu-button"
          data-testid={`${AlarmNotificationProfileMenuActionsType.Delete}-button`}
          text={t('collectionFunction.grid.delete')}
          onClick={handleOpenDeleteDialog}
        />
      )}
      <ModalDialog
        width="500px"
        isOpen={isDeleteDialogOpen}
        title={t('alarmNotificationProfile.deletePopup.title')}
        displayMessage={
          t('collectionFunction.deletePopup.message', { name: selectedItem.name })
        }
        actionText={t('collectionFunction.deletePopup.action')}
        onSubmit={handleDelete}
        onClose={handleCloseDeleteDialog}
      />
    </div>
  );
};

export default AlarmNotificationProfileMenu;
